import React from 'react';
import { useTranslation } from 'react-i18next';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SophisticatedFtueTooltip from '../../../Popover/Preset/SophisticatedFtueTooltip';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
/** The tooltip that appears on mobile when the user views their
 *  first in-tier journal or lit. */ const SubscriptionLockLitFTUETooltip = ({ deviation, linkClassName, children })=>{
    const { t } = useTranslation();
    const { subscriptionsTabUrl } = useSubscriptionTier(deviation);
    return /*#__PURE__*/ React.createElement(SophisticatedFtueTooltip, {
        flag: FirstTimeFlag.IsMsLockedArtNotSeen,
        hasCloseButton: true,
        size: "medium",
        placement: "top",
        heading: t('deviation.tier.subscribersOnly.tooltip.lockFtue.heading'),
        description: t('deviation.tier.subscribersOnly.tooltip.lockFtue.description'),
        postfix: /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
            href: subscriptionsTabUrl,
            className: linkClassName
        }, t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink'))
    }, children);
};
SubscriptionLockLitFTUETooltip.displayName = 'SubscriptionLockLitFTUETooltip';
export default SubscriptionLockLitFTUETooltip;

//# sourceMappingURL=SubscriptionLockLitFTUETooltip.js.map